export default theme => ({
  root: {},
  masterButton: {
    float: 'right'
  },
  controlButton: {
    display: 'block',
    width: '100%',
    textAlign: 'left',
    marginTop: theme.spacing(1),
  },
  controlButtonIcon: {
    verticalAlign: 'middle'
  },
  deleteButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.danger.main,
    '&:hover': {
      backgroundColor: theme.palette.danger.dark,
      color: theme.palette.common.white,
    }
  }
});
